module.exports = __webpack_public_path__ + "static/img/outline.f6c75f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/collection/outline.png
// module id = Cq6J
// module chunks = 1